"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FiatForm = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactstrap = require("reactstrap");
var _reactHookForm = require("react-hook-form");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../../../ui");
var _fields = require("../../../../fields");
var _hooks = require("../../../../../hooks");
var _TickerGroup = require("./TickerGroup");
var _BalanceGroup = require("./BalanceGroup");
var _Footer = require("./Footer");
var _form = require("../../form");
var _ModeTabsNav = require("../ModeTabsNav");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var InputCurrencyText = (0, _styledComponents.default)(_ui.MediumSpan)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiaryShade;
});
var FiatForm = function FiatForm(_ref2) {
  var balanceName = _ref2.balanceName,
    children = _ref2.children;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libTransfers', 'libCommon']),
    t = _useTranslation.t;
  var _useFormContext = (0, _reactHookForm.useFormContext)(),
    control = _useFormContext.control,
    handleSubmit = _useFormContext.handleSubmit;
  var props = (0, _hooks.useWithdrawContext)();
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Form, {
    onSubmit: handleSubmit(props.onFormSubmit),
    noValidate: true
  }, /*#__PURE__*/_react.default.createElement(_ModeTabsNav.ModeTabsNav, {
    activeTab: _ModeTabsNav.Mode.SEND,
    onTabChange: props.setMode
  }), props.loading ? /*#__PURE__*/_react.default.createElement(_ui.Spinner, {
    size: "lg",
    color: "primary"
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children, /*#__PURE__*/_react.default.createElement(_TickerGroup.TickerGroup, null), /*#__PURE__*/_react.default.createElement(_BalanceGroup.BalanceGroup, {
    balanceName: balanceName
  }), /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('destinationCard')), /*#__PURE__*/_react.default.createElement(_fields.CardNumberInputField, {
    control: control,
    inputProps: {
      name: 'address'
    }
  })), /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('amount')), /*#__PURE__*/_react.default.createElement(_ui.InputGroupAbsolute, null, /*#__PURE__*/_react.default.createElement(_ui.InputGroupAddon, {
    addonType: "append"
  }, /*#__PURE__*/_react.default.createElement(InputCurrencyText, null, props.ticker)), /*#__PURE__*/_react.default.createElement(_fields.TickerNumberFormatInputField, {
    control: control,
    inputProps: {
      name: 'amount',
      ticker: props.ticker,
      onFocus: props.onAmountInputFocus,
      decimals: 0
    }
  })), !props.priceLoading && /*#__PURE__*/_react.default.createElement(_form.Rate, {
    ticker: props.ticker,
    convertedTicker: props.fiatTicker,
    price: props.price
  })), /*#__PURE__*/_react.default.createElement(_fields.InputField, {
    control: control,
    inputProps: {
      hidden: true,
      name: 'fiatTickerAmount'
    }
  }), /*#__PURE__*/_react.default.createElement(_Footer.Footer, {
    fiat: true
  })));
};
exports.FiatForm = FiatForm;